/**
 * Missing translation key collector.
 * Batches missing keys over 10 seconds and sends a single notification email.
 */

import { supabase } from '@/integrations/supabase/client';

interface MissingKey {
  lng: string;
  ns: string;
  key: string;
  fallbackValue: string;
}

let buffer: MissingKey[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

const DEBOUNCE_MS = 10_000;

async function flush() {
  if (buffer.length === 0) return;
  const batch = [...buffer];
  buffer = [];

  // Only send in production-like environments
  if (import.meta.env.DEV) {
    console.warn('[i18n] Missing keys:', batch);
    return;
  }

  try {
    await supabase.functions.invoke('admin-notification', {
      body: {
        type: 'missing_translations',
        keys: batch,
      },
    });
  } catch (err) {
    console.error('[i18n] Failed to report missing keys:', err);
  }
}

export function handleMissingKey(
  lngs: readonly string[],
  ns: string,
  key: string,
  fallbackValue: string,
) {
  const lng = lngs[0] || 'unknown';
  // Don't report missing keys for English — those are the source
  if (lng === 'en') return;

  buffer.push({ lng, ns, key, fallbackValue });

  if (timer) clearTimeout(timer);
  timer = setTimeout(flush, DEBOUNCE_MS);
}
